import { createGlobalStyle } from 'styled-components';
import { ITheme } from '../interfaces';
import robotoBold from '../fonts/Roboto/Roboto-Bold.ttf';
import robotoMedium from '../fonts/Roboto/Roboto-Medium.ttf';
import robotoLight from '../fonts/Roboto/Roboto-Light.ttf';
import robotoRegular from '../fonts/Roboto/Roboto-Regular.ttf';

import playfairDisplayExtraBold from '../fonts/Playfair_Display/static/PlayfairDisplay-ExtraBold.ttf';

//C:/Users\93luc\DEV\Travessias2\src\front-novo\fonts\Playfair_Display\static\PlayfairDisplay-ExtraBold
//Roboto-Medium
const GlobalStyle = createGlobalStyle<{ theme: ITheme }>`
* {
  margin: 0;
  padding: 0;
  // width: 100%;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  transition: 0.5s;
  // font-family: 'Roboto Bold', sans-serif;
   line-height: 1.2; /* Espaçamento entre linhas de 1.6 vezes o tamanho da fonte */
  hr {
    display: block;
    // margin-top: 0;
    // margin-bottom: 0;
    // margin-left: auto;
    // margin-right: auto;
    border: none;
    // border-style: inset;
    height: 0.5px;
    // border-width: 1px;
  background-color: ${({ theme }) => theme.font4};
    
  }
}
button {
    cursor: pointer;
}
@font-face {
  font-family: 'roboto Medium';
  src: url(${robotoMedium}) format('truetype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto Light';
  src: url(${robotoLight}) format('truetype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto Bold';
  src: url(${robotoBold}) format('truetype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto Regular';
  src: url(${robotoRegular}) format('truetype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'playfairDisplayExtraBold';
  src: url(${playfairDisplayExtraBold}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

.main {
  width: 100%;
}

main {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.background1};
}

a {
  text-decoration: none;
}
`;

export default GlobalStyle;
